import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { isFunderFoundation, isFunderGrantmaking } from 'utils/helpers'

import { selectFunderProfileInfo } from 'store/selectors/profile'

const NotEngagedNote = () => {
  const { i18n } = useTranslation()
  const t = i18n.getResourceBundle(i18n.language)
  const { funderActivityOption, primaryCategory } = useSelector(selectFunderProfileInfo)

  return (
    !isFunderGrantmaking(funderActivityOption, t) &&
    isFunderFoundation(primaryCategory, t) && (
      <div className="profile-grantmaking-notes">
        <div className="profile-grantmaking-notes-note">{t.funder.organizationNotEngaged}</div>
      </div>
    )
  )
}

export default NotEngagedNote
